import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { Observable, Subscriber } from 'rxjs';
import { Location } from '@angular/common';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-transcript',
  templateUrl: './transcript.component.html',
  styleUrls: ['./transcript.component.scss']
})
export class TranscriptComponent implements OnInit {
  TranscriptForm: FormGroup;
  @ViewChild('fileUploader') fileUploader: ElementRef;
  Tclcdata = [];
  dialogRef: MatDialogRef<any>;
  TCList: any;
  filterTCList: any;
  filteredCollegeList: any;
  CollegeList: any;
  examList: any;
  filteredExamList: any;
  courseStreamList: any;
  filteredStreamList: any;
  courseList: any;
  filteredCourseList: any;
  DestcollegeList: any;
  filteredDestCollegeList: any;
  StuId: any;
  TclcData: any;
  Table = false;
  Approved = false;
  InstId: any;
  RptCode: number;
  College = true;
  PayFee = false
  CgCode: any;
  filteredDestUniList: any;
  DestUniList: any;
  Status: string;
  // SaveDisabled: boolean;
  SaveDisabled = false;
  CertStatus: any;
  Other = false;
  SaveBtn = false;
  UpdateBtn = false;
  PayDisabled = false;
  PayRecpt = false;
  DocTable = false;
  StuFullName: string;
  currentdate: Date;
  formattedPrn: string;
  RgNo: string;
  PreFix: any;
  fileName: string;
  errormessage: string;
  isdisabled=false;
  documents = [
    { id: 1, name: 'First Year to Final Year Marksheets (One Set)' },
    { id: 2, name: 'Internship Completion Certificate, Passing Certificate, Degree Certificate' },
    { id: 3, name: 'Registration Certificate, Identity Certificate (Aadhar/Passport)' }
  ];
  uploadDoc: any;
  fileUploads: any;
  AppliDate: any;
  RegnNo: any;
  errMsg: any;
  DocView = false;
  TclcId: any;
  TclcDocData: any;
  UpdateDisabled = false;
  ForeignUni: boolean;
  UniName:string;
  UniAddress: string;
  IsWES: boolean;
  UniDocName: string;
  UniDocRefNo: string;
  UniDocUpload: any;
  isSameAddr: boolean;
  isreadonly = false;
  uniDetailsFormArray;

  deliveryList = [
    { value: 'option1', dropdownValue:'Soft', Value: 'Soft Copy' },
    { value: 'option1', dropdownValue:'Hard', Value: 'Hard Copy' },
    { value: 'option1', dropdownValue:'Both', Value: 'Both' }
  ];
  TranscriptData: any;
  uploadDoc2: any;
  FeeStatus: any;
  applyUniversity: any;
  filteredapplyUniversity: any;
  AdminUpload: any = [];


  constructor(private http: HttpClient, private location: Location,private cdr: ChangeDetectorRef, public umsService: UmsService, private fb: FormBuilder, public dialog: MatDialog,
    private modalPopupService: ModalpopService, private spinner: NgxSpinnerService, public router: Router,
  ) { }
  BranchId = 0;
  minDate = new Date(2000, 0, 1); 
  ngOnInit(): void {
    this.currentdate = new Date();
    this.UpdateBtn = false;
    this.isdisabled=false;
    this.DocTable = false;
    this.DocView = false;
    this.SaveBtn = false;
    this.Other = false;
    this.College = true;
    this.PayFee = false;
    this.Table = false;
    this.UpdateDisabled = false;
    this.PayDisabled = false
    this.RgNo = sessionStorage.getItem('StudentRGID');
    this.TranscriptForm = this.fb.group({
      StuCourse: new FormControl(''),
      StuClg: new FormControl(''),
      StuName: new FormControl(''),
      StuFromDate: new FormControl('',[ Validators.required, this.validYearValidator]),
      StuToDate: new FormControl('', [Validators.required, this.validYearValidator]),
      CouncilRegNo: new FormControl('', Validators.required),
      StuAdd: new FormControl(''),
      StuPin: new FormControl(''),
      StuPhone: new FormControl(''),
      StuEmail: new FormControl(''),
      StuCertCopies: new FormControl('', Validators.required),
      AdmDate: new FormControl(''),
      TranscriptId: new FormControl(''),
      arrData: this.fb.array([]),
      ForeignUni: new FormControl('', Validators.required),
      UniName: new FormControl(''),
      UniAddress: new FormControl(''),
      IsWES: new FormControl(''),
      UniDocName: new FormControl(''),
      UniDocRefNo: new FormControl(''),
      UniDocUpload: new FormControl(''),
      docFile: new FormControl(''),
      DeliveryOpt: new FormControl('', Validators.required),
      PostalAdd: new FormControl(''),
      EmailId: new FormControl(''),
      isSameAddr: new FormControl(''),
      uniDocFile: new FormControl('')


    })
 
    this.getStuId()
    this.getSecretData();
    this.getDate()
    this.fetchApplyUni()
    this.transPRN(this.RgNo)

  

  }

  onDrpChange(e){
    this.TranscriptForm.controls["UniDocName"].setValue(e.CdDesc);
    
  }

  copyUniAddress(e) {
    if(e.checked === true) {
      this.isreadonly = true;
      this.TranscriptForm.controls["PostalAdd"].setValue(this.TranscriptForm.controls["UniAddress"].value)
    }
    else {
      this.isreadonly = false;
      this.TranscriptForm.controls["PostalAdd"].setValue('')
    }
  }

  validYearValidator = (control: AbstractControl) => {
    const inputDate = control.value;
    if (inputDate && !isNaN(Date.parse(inputDate))) {
      const year = new Date(inputDate).getFullYear();
      if (year < 1000 || year > 9999) {
        return { invalidYear: true };
      }
    }
    return null; // No error
  };


  getSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.InstId = res.projectPharam['ClubPartTrans']
      }
      else{

      }
     
    }, (ERROR:HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getDate() {
    this.spinner.show()
    let payload2 = {};
    payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload2['SessionId'] = parseInt(sessionStorage.getItem('session'));
    this.umsService.fetchApplicationDetails(payload2).subscribe((res) => {
      if(res.status){
        res.data.forEach((element) => {
          if (element.ApplicationName == 'Registration') {
            this.AppliDate = element.ApplicationSubDate;
            this.TranscriptForm.controls['AdmDate'].setValue(this.AppliDate)
          }
        });
      }
      else{

      }
    
    },(ERROR:HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  transPRN(RgNo) {
    this.formattedPrn = RgNo.toString().padStart(8, '0');
  }

  getStuId() {
  
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.TranscriptForm.controls['StuEmail'].setValue(res.data[0].EmailID)
        this.TranscriptForm.controls['StuPhone'].setValue(res.data[0].StuNumber)
        this.RegnNo = res.data[0]['StuRgNo']
        
        this.GetTranscript(res.data[0].StuId)
        this.StuId = res.data[0].StuId;
        this.getUserData()
        this.RgId(res.data[0].StuId)
        this.SubjectSelectionData(res.data[0].StuId)
        this.ContactDetails(res.data[0].StuId)
        // this.spinner.hide()
      }
      else {
        // this.spinner.hide()
        this.SaveDisabled = true;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisabled = true;
    })
  }

  getUserData() {
    this.spinner.show()
    this.umsService.getUserData(sessionStorage.getItem('StudentRGID')).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.StuFullName = res.data[0][0]['StuFirstName'] + ' ' + res.data[0][0]['StuMidName'] + ' ' + res.data[0][0]['StuLastName'];
        this.TranscriptForm.controls['StuName'].setValue(this.StuFullName)
      }
      else {
        // this.spinner.hide()
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  RgId(StuId) {
    this.spinner.show()
    const payload = {};
    payload['StuId'] = StuId;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        // this.SaveDisabled = true;
        this.SaveBtn = true;
      }
      else {
        // this.spinner.hide()
        this.SaveDisabled = true;
        this.SaveBtn = false;
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.SaveDisabled = true;
      this.SaveBtn = false;
    })
  }

  SubjectSelectionData(StuId) {
    this.spinner.show()
    const payload = {};
    payload['StuId'] = StuId
    this.umsService.StudentSubjectSelectionById(payload).subscribe(res => {
      if (res.status) {
        // this.spinner.hide()
        const latestObject = res.data[res.data.length - 1];
        this.getCourseData(latestObject['SubCoId']);
        this.getCollege(latestObject['SubCgId']);
      }
      else {
        // this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getCourseData(CoCode) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.fetchCourseType(payload).subscribe(res => {
      if (res.status) {
        // this.spinner.hide()
        this.courseList = res.data;
        this.PreFix = res.data[0].CoRgPrfx
        this.filteredCourseList = this.courseList.slice();
        this.TranscriptForm.controls['StuCourse'].setValue(res.data[0]['CoCode'])
      }
      else {
        // this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  getCollege(CgCode) {
    this.spinner.show()
    const payload3 = {};
    this.umsService.getCollege(payload3).subscribe(res => {
      if (res.status) {
        // this.spinner.hide()
        this.CollegeList = res.data.filter(record => record.CgCode === CgCode);
        this.filteredCollegeList = this.CollegeList.slice();
        this.TranscriptForm.controls['StuClg'].setValue(this.CollegeList[0]['CgCode'])
        this.CgCode = CgCode
        // this.DestcollegeList = res.data.filter(record => record.CgCode != CgCode)
        // this.filteredDestCollegeList = this.DestcollegeList.slice();
      }
      else {
        // this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  ContactDetails(StuID) {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = StuID
    this.umsService.GetStuAddress(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.TranscriptForm.controls['StuPin'].setValue(res.data[0].StuPinC)
        this.TranscriptForm.controls['StuAdd'].setValue(res.data[0].FullAddress)
      }
      else {
        // this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  GetTranscript(StuId) {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = StuId
    this.umsService.SearchTranscript(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.UpdateBtn = true;
        this.isdisabled=true;
        this.SaveBtn = false
        this.TranscriptData = res.data
        this.TranscriptForm.controls['StuCertCopies'].setValue(res.data[0].StuCertCopies)
        this.TranscriptForm.controls['CouncilRegNo'].setValue(res.data[0].CouncilRegNo)
        this.TranscriptForm.controls['StuFromDate'].setValue(res.data[0].StuFromDate)
        this.TranscriptForm.controls['StuToDate'].setValue(res.data[0].StuToDate)
        this.TranscriptForm.controls['TranscriptId'].setValue(res.data[0].TranscriptId)
        this.TranscriptForm.controls['DeliveryOpt'].setValue(res.data[0].DeliveryOpt)
        this.TranscriptForm.controls['EmailId'].setValue(res.data[0].EmailId)
        this.TranscriptForm.controls['ForeignUni'].setValue(res.data[0].ForeignUni)
        this.TranscriptForm.controls['IsWES'].setValue(res.data[0].IsWES)
        this.TranscriptForm.controls['PostalAdd'].setValue(res.data[0].PostalAdd)
        this.TranscriptForm.controls['UniAddress'].setValue(res.data[0].UniAddress)
        this.TranscriptForm.controls['UniDocName'].setValue(res.data[0].UniDocName)
        this.TranscriptForm.controls['UniDocRefNo'].setValue(res.data[0].UniDocRefNo)
        this.TranscriptForm.controls['UniName'].setValue(res.data[0].UniName)
        this.TranscriptForm.controls['UniDocUpload'].setValue(res.data[0].UniDocUpload)
        if(res.data[0].PostalAdd == res.data[0].UniAddress && res.data[0].ForeignUni == 'Y'){
          this.TranscriptForm.controls['isSameAddr'].setValue(true)
        }
        // this.GetTranscriptData(StuId)
        this.getTclcData(StuId)
      }
      else {
        // this.spinner.hide()
        this.UpdateBtn = false;
        this.SaveBtn = true
        this.isdisabled=false;
        this.GetTranscriptData(StuId)
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getTclcData(StuId){
    this.spinner.show()
    const payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CertType'] = 'TS'
    payload['IsStudent'] = 1
    payload['StuId'] = this.StuId
    this.umsService.GetTclcData(payload).subscribe((res) => {
      if(res.status){
        // this.spinner.hide()
        // this.TclcData = res.data.filter(data => data.StuId == this.StuId)
        this.TclcData = res.data
        if(this.TclcData != ''){
          if(this.TclcData[0]['FeeStatus'] == 'Y'){
            this.PayFee = false;
            this.PayDisabled = true;
            this.PayRecpt = true;
            this.FeeStatus = this.TclcData[0]['FeeStatus']
          }
          else if(this.TclcData[0]['FeeStatus'] != 'Y'){
            this.PayDisabled = false;
            this.PayRecpt = false
            this.ValidateFee(this.TclcData[0]['StuId'],this.TclcData[0]['CertType'],this.TclcData[0])
          }
          if(this.TclcData[0]['CertType'] == 'TS'){
            this.SaveBtn = false;
            this.UpdateBtn = true;
            this.isdisabled=true;
          }
          else if(this.TclcData[0]['CertType'] != 'TS' && this.TclcData[0]['CertStatus'] == 'REJ'){
            this.SaveBtn = true;
            this.SaveDisabled = false
            this.UpdateBtn = false;
            this.isdisabled=false;
          }
          else{
            this.SaveBtn = true;
            this.SaveDisabled = true;
            this.UpdateBtn = false;
            this.isdisabled=false;
          }
          switch (this.TclcData[0]['CertStatus']) {
            case "APR":
              if(this.TclcData[0]['CertType'] == "ADMC"){
                if(this.TclcData[0]['RgStatus'] == "L"){
                  this.Status = 'Application Approved'
                }
                else if(this.TclcData[0]['RgStatus'] == " "){
                  this.Status = 'Application InProcess'
                }
              }
              else{
                this.Status = 'Approved';
              }
              this.UpdateDisabled = true;
              break;
            case "APPAP":
              if(this.TclcData[0]['CertType'] == "ADMC"){
                if(this.TclcData[0]['RgStatus'] == "L"){
                  this.Status = 'Application Approved'
                }
                else if(this.TclcData[0]['RgStatus'] == " "){
                  this.Status = 'Application InProcess'
                }
              }
              else{
                this.Status = 'Application Approved'
              }
              this.UpdateDisabled = true;
              break;  
            case "REJ":
              this.Status = 'Rejected'
              this.UpdateDisabled = true;
              break;
            case "REC":
              this.Status = 'Rectify';
              this.UpdateDisabled = false;
              break;
            case "Fees Paid":
              this.UpdateDisabled = true;
              this.Status = 'Fees Paid'
              break;
            case "ReSubmitted":
              this.Status = 'Re-Submitted'
              this.UpdateDisabled = false;
              break;
            case "Submitted":
              this.Status = 'Submitted'
              this.UpdateDisabled = true;
              this.PayFee = true
              break;
            case "UFD":
                this.Status = 'Certificate Generated'
                this.UpdateDisabled = true;
                this.UploadedDocs();
                break;
            default:
              this.UpdateDisabled = false;
              this.Status = this.TclcData[0]['CertStatus']
              break
          }
          // if(this.TclcData[0]['CertStatus'] == 'Submitted'){
          //   this.PayFee = true
          //   // this.UpdateDisabled = true;
          // }
          // else{
          //   this.PayFee = false
          //   // this.UpdateDisabled = false;
          // }
         
          if(this.TclcData[0]['CertStatus'] == 'APR' && this.TclcData[0]['CertType'] != "ADMC"){
            this.Approved = true
            // this.spinner.hide()
          }
          else{
            this.Approved = false
            // this.spinner.hide()
          }
          this.Table = true
          this.TclcId = this.TclcData[0]['TclcId']
        }
        else{
          this.Table = false;
        }
        this.GetTranscriptData(StuId)
      }
      else{
        this.GetTranscriptData(StuId)
        // this.spinner.hide()
      }
    },(ERROR:HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  GetTranscriptData(StuId) {
    this.spinner.show(); // Show the spinner at the beginning
    const creds = this.TranscriptForm.controls.arrData as FormArray;
    creds.clear();
    this.SaveDisabled = false;
    let payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
    payload['CertType'] = 'TS'
    this.umsService.GetTcLcDocDetails(payload).subscribe(
        (res) => {
            if (res.status) {
              this.spinner.show()
                this.TclcDocData = res.data.filter(record => record.StuId == StuId);

                if (this.TclcDocData && this.TclcDocData.length > 0) {
                    this.DocView = true;
                    this.SaveBtn = false;
                    this.UpdateBtn = true;
                    this.isdisabled=true;

                    creds.clear(); // Clear existing form data
                    this.TclcDocData.forEach((obj, i) => {
                        const tempObj = {
                            DocumentName: new FormControl(obj.DocName),
                            SrNo: new FormControl(obj.SrNo),
                            docFile: new FormControl(''),
                            DocumentFile: new FormControl(obj.FileUpload),
                            TclcDocId: new FormControl(obj.TclcDocId)
                        };

                        // Initialize fileUploads array if undefined
                        if (!this.fileUploads) {
                            this.fileUploads = [];
                        }

                        // Ensure the row index exists
                        if (!this.fileUploads[i]) {
                            this.fileUploads[i] = {};
                        }
                        this.fileUploads[i] = obj.FileUpload;

                        // Push the new form group
                        creds.push(new FormGroup(tempObj));
                    });

                    this.DocTable = true; // Set DocTable to true when data is present
                    this.spinner.hide()
                } else {
                    this.DocView = false;
                    this.CommonDocument(StuId);
                }
            } else {
                this.DocView = false;
                this.CommonDocument(StuId);
            }
        },
        (ERROR: HttpErrorResponse) => {
            console.error('Error occurred:', ERROR);
            this.spinner.hide(); // Hide spinner if an error occurs
            this.cdr.detectChanges(); // Trigger change detection
        }
    );
}
  


  CommonDocument(StuId) {
    this.DocTable = false;
    this.spinner.show()
    this.DocView = false;
    let payload = {};
    payload['ModuleType'] = 'TS'
    this.umsService.CommonDocument(payload).subscribe((res) => {
      if (res.status) {
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.isdisabled=false;
        const arrayOfObjects = res.data;
        this.spinner.show()
        arrayOfObjects.forEach((obj, i) => {
          const tempObj = {}
          let regex = '';
          if (obj.RegEx !== null) {
            regex = obj.RegEx
          }
          tempObj['DocumentName'] = new FormControl(obj.DocName),
            tempObj['SrNo'] = new FormControl(obj.SrNo),
            tempObj['docFile'] = new FormControl(''),
            tempObj['DocumentFile'] = new FormControl(''),
            tempObj['TclcDocId'] = new FormControl('')
          for (const key in tempObj) {
          }

          const creds = this.TranscriptForm.controls.arrData as FormArray;
          creds.push(new FormGroup(tempObj));

        })
        this.DocTable = true;
        this.spinner.hide();
      }
      else {
        this.DocTable = false
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  Save() {
    if (this.TranscriptForm.invalid) {
      this.TranscriptForm.get('StuFromDate').markAsTouched();
      this.TranscriptForm.get('StuToDate').markAsTouched();
      this.TranscriptForm.get('CouncilRegNo').markAsTouched();
      this.TranscriptForm.get('StuCertCopies').markAsTouched();
      this.TranscriptForm.get('ForeignUni').markAsTouched();
      this.TranscriptForm.get('DeliveryOpt').markAsTouched();
      if(this.TranscriptForm.value.ForeignUni == 'Y'  && (this.TranscriptForm.value.UniName == '' || this.TranscriptForm.value.UniAddress == '' || this.TranscriptForm.value.UniDocRefNo == '' || this.TranscriptForm.value.UniDocUpload == '')){
        this.TranscriptForm.get('UniName').setValidators([Validators.required]);
        this.TranscriptForm.get('UniName').updateValueAndValidity();
        this.TranscriptForm.get('UniAddress').setValidators([Validators.required]);
        this.TranscriptForm.get('UniAddress').updateValueAndValidity();
        this.TranscriptForm.get('UniDocRefNo').setValidators([Validators.required]);
        this.TranscriptForm.get('UniDocRefNo').updateValueAndValidity();
        this.TranscriptForm.get('UniDocUpload').setValidators([Validators.required]);
        this.TranscriptForm.get('UniDocUpload').updateValueAndValidity();
        
        this.TranscriptForm.get('UniDocRefNo').markAsTouched();
        this.TranscriptForm.get('UniDocUpload').markAsTouched(); 
        this.TranscriptForm.get('UniName').markAsTouched();
        this.TranscriptForm.get('UniAddress').markAsTouched();        
      }
      else if(this.TranscriptForm.value.ForeignUni == 'N'){
        this.TranscriptForm.get('UniName').clearValidators()
        this.TranscriptForm.get('UniName').updateValueAndValidity();
        this.TranscriptForm.get('UniAddress').clearValidators()
        this.TranscriptForm.get('UniAddress').updateValueAndValidity();
        this.TranscriptForm.get('UniDocRefNo').clearValidators()
        this.TranscriptForm.get('UniDocRefNo').updateValueAndValidity();
        this.TranscriptForm.get('UniDocUpload').clearValidators()
        this.TranscriptForm.get('UniDocUpload').updateValueAndValidity();
      }
      if(this.TranscriptForm.value.DeliveryOpt == 'Soft' && this.TranscriptForm.value.EmailId == ''){
        this.TranscriptForm.get('EmailId').setValidators([Validators.required]);
        this.TranscriptForm.get('EmailId').updateValueAndValidity();
        this.TranscriptForm.get('EmailId').markAsTouched();
      }
      else if(this.TranscriptForm.value.DeliveryOpt == 'Soft' && this.TranscriptForm.value.PostalAdd != ''){
        this.TranscriptForm.get('EmailId').clearValidators()
        this.TranscriptForm.get('EmailId').updateValueAndValidity();
      }
      else if(this.TranscriptForm.value.DeliveryOpt == 'Hard' && this.TranscriptForm.value.PostalAdd == ''){
        this.TranscriptForm.get('PostalAdd').setValidators([Validators.required]);
        this.TranscriptForm.get('PostalAdd').updateValueAndValidity();
        this.TranscriptForm.get('PostalAdd').markAsTouched();
      }
      else if(this.TranscriptForm.value.DeliveryOpt == 'Hard' && this.TranscriptForm.value.PostalAdd != ''){
        this.TranscriptForm.get('PostalAdd').clearValidators()
        this.TranscriptForm.get('PostalAdd').updateValueAndValidity();
      }
      const creds = this.TranscriptForm.get('arrData') as FormArray;

      creds.controls.forEach(element => {
        if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').updateValueAndValidity();
          element.get('DocumentFile').markAsTouched();
        }
        else {
          element.get('DocumentFile').clearValidators()
          element.get('DocumentFile').updateValueAndValidity();
        }

      })

    }
    else {
      const creds = this.TranscriptForm.get('arrData') as FormArray;
      let allValid = true;
      creds.controls.forEach(element => {
        if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').updateValueAndValidity();
          element.get('DocumentFile').markAsTouched();
          allValid = false;
        }
        else {
          element.get('DocumentFile').clearValidators()
          element.get('DocumentFile').updateValueAndValidity();
          // this.Submit()
        }
        if(this.TranscriptForm.value.ForeignUni == 'Y' && (this.TranscriptForm.value.UniName == '' || this.TranscriptForm.value.UniAddress == '' || this.TranscriptForm.value.UniDocRefNo == '' || this.TranscriptForm.value.UniDocUpload == '')){
          this.TranscriptForm.get('UniName').setValidators([Validators.required]);
          this.TranscriptForm.get('UniName').updateValueAndValidity();
          this.TranscriptForm.get('UniAddress').setValidators([Validators.required]);
          this.TranscriptForm.get('UniAddress').updateValueAndValidity();
          this.TranscriptForm.get('UniDocRefNo').setValidators([Validators.required]);
          this.TranscriptForm.get('UniDocRefNo').updateValueAndValidity();
          this.TranscriptForm.get('UniDocUpload').setValidators([Validators.required]);
          this.TranscriptForm.get('UniDocUpload').updateValueAndValidity();
          
          this.TranscriptForm.get('UniDocRefNo').markAsTouched();
          this.TranscriptForm.get('UniDocUpload').markAsTouched(); 
          this.TranscriptForm.get('UniName').markAsTouched();
          this.TranscriptForm.get('UniAddress').markAsTouched();    
          allValid = false;    
        }
        else if(this.TranscriptForm.value.ForeignUni == 'N'){
          this.TranscriptForm.get('UniName').clearValidators()
          this.TranscriptForm.get('UniName').updateValueAndValidity();
          this.TranscriptForm.get('UniAddress').clearValidators()
          this.TranscriptForm.get('UniAddress').updateValueAndValidity();
          this.TranscriptForm.get('UniDocRefNo').clearValidators()
          this.TranscriptForm.get('UniDocRefNo').updateValueAndValidity();
          this.TranscriptForm.get('UniDocUpload').clearValidators()
          this.TranscriptForm.get('UniDocUpload').updateValueAndValidity();
          allValid = true;
        }
        if(this.TranscriptForm.value.DeliveryOpt == 'Soft' && this.TranscriptForm.value.EmailId == ''){
          this.TranscriptForm.get('EmailId').setValidators([Validators.required]);
          this.TranscriptForm.get('EmailId').updateValueAndValidity();
          this.TranscriptForm.get('EmailId').markAsTouched();
          allValid = false;
        }
        else if(this.TranscriptForm.value.DeliveryOpt == 'Soft' && this.TranscriptForm.value.PostalAdd != ''){
          this.TranscriptForm.get('EmailId').clearValidators()
          this.TranscriptForm.get('EmailId').updateValueAndValidity();
        }
        else if(this.TranscriptForm.value.DeliveryOpt == 'Hard' && this.TranscriptForm.value.PostalAdd == ''){
          this.TranscriptForm.get('PostalAdd').setValidators([Validators.required]);
          this.TranscriptForm.get('PostalAdd').updateValueAndValidity();
          this.TranscriptForm.get('PostalAdd').markAsTouched();
          allValid = false;
        }
        else if(this.TranscriptForm.value.DeliveryOpt == 'Hard' && this.TranscriptForm.value.PostalAdd != ''){
          this.TranscriptForm.get('PostalAdd').clearValidators()
          this.TranscriptForm.get('PostalAdd').updateValueAndValidity();
        }
      })
      if (allValid) {
        this.Submit();
      }
    }
  }

  Submit() {
    this.spinner.show();
    const submitpayload = this.TranscriptForm.value
    let payload = {}
    payload['StuId'] = this.StuId
    payload['StuFromDate'] = submitpayload.StuFromDate
    payload['StuToDate'] = submitpayload.StuToDate
    payload['CouncilRegNo'] = submitpayload.CouncilRegNo
    payload['StuCertCopies'] = submitpayload.StuCertCopies
    payload['FeeStatus'] = ''
    payload['CertType'] = 'TS'
    payload['CertStatus'] = 'Submitted'
    payload['StatusBy'] = sessionStorage.getItem('loginId')
    payload['DocStatus'] = 'Y'
    payload['Comment'] = ''
    payload['SnNo'] = parseInt(sessionStorage.getItem('session'))
    payload['StuName'] = submitpayload.StuName
    payload['ForeignUni'] = submitpayload.ForeignUni
    payload['UniName'] = submitpayload.UniName
    payload['UniAddress'] = submitpayload.UniAddress
    payload['IsWES'] = submitpayload.IsWES
    payload['UniDocName'] = submitpayload.UniDocName
    payload['UniDocRefNo'] = submitpayload.UniDocRefNo
    payload['UniDocUpload'] = this.uploadDoc2
    payload['PostalAdd'] = submitpayload.PostalAdd
    payload['EmailId'] = submitpayload.EmailId
    payload['DeliveryOpt'] = submitpayload.DeliveryOpt
    this.umsService.AddTranscript(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.SubmitTclc();
        // let data = {}
        // data['message'] = "Submitted Successfully"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   // this.SaveDisabled = true;
        //   this.ShowGrid()
        // });

      }
      else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    })
  }


  SubmitTclc() {
    const submitpayload = this.TranscriptForm.value
    let payload = {}
    payload['StuFaculty'] = '',
      payload['StuCourse'] = submitpayload.StuCourse,
      payload['StuCollege'] = submitpayload.StuClg,
      payload['StuExam'] = '',
      payload['StuBranch'] = '',
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = 'TS',
      payload['DestClg'] = '',
      payload['Reason'] = '',
      payload['Other'] = '',
      payload['FeeStatus'] = '';
    payload['CertStatus'] = 'Submitted';
    payload['StuId'] = this.StuId;
    payload['Comment'] = '';
    payload['CertScr'] = '';
    payload['StatusBy'] = sessionStorage.getItem('loginId');
    payload['DocStatus'] = 'Y';
    this.umsService.AddTclc(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.AddTclcDoc()
        // let data = {}
        // data['message'] = "Submitted Successfully"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   // this.SaveDisabled = true;
        //   this.ShowGrid()
        // });

      }
      else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    })
  }

  AddTclcDoc() {
    const submitpayload = this.TranscriptForm.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.TranscriptForm.controls.arrData.value.forEach((element, index, array) => {
        let payload = {};
        payload['StuId'] = this.StuId,
          payload['CertType'] = 'TS',
          payload['DocName'] = element.DocumentName,
          payload['FileUpload'] = this.fileUploads[index];
        payload['SrNo'] = element.SrNo
        setTimeout(() => {
          this.umsService.AddTclcDoc(payload).subscribe(res => {
            // this.spinner.hide();
            if (res.status == false) {
              // this.spinner.hide()
              iserror = true;
              this.errMsg = res.message;
            } else {
              // this.spinner.hide()
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            // this.fetchDocument();
            this.fileUploader.nativeElement.value = null;
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      // this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();

        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ShowGrid()
          this.GetTranscript(this.StuId)

        });
        this.saveApplicationDetails();
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ShowGrid()
        });
      }
    });

  }

  saveApplicationDetails() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StuId;
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'))
    payload['CgCode'] = this.TranscriptForm.value['StuClg']
    payload['CoCode'] = this.TranscriptForm.value['StuCourse']
    payload['ApplicationName'] = 'TS'
    payload['ApplicationSubDate'] = formattedDate
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    })
  }

  Update() {
    this.spinner.show();
    const submitpayload = this.TranscriptForm.value
    let payload = {}
    payload['StuId'] = this.StuId
    payload['StuFromDate'] = submitpayload.StuFromDate
    payload['StuToDate'] = submitpayload.StuToDate
    payload['CouncilRegNo'] = submitpayload.CouncilRegNo
    payload['StuCertCopies'] = submitpayload.StuCertCopies
    payload['FeeStatus'] = 'Y'
    payload['CertType'] = 'TS'
    payload['CertStatus'] = 'ReSubmitted'
    payload['StatusBy'] = sessionStorage.getItem('loginId')
    payload['DocStatus'] = 'Y'
    payload['Comment'] = ''
    payload['SnNo'] = parseInt(sessionStorage.getItem('session'))
    payload['StuName'] = submitpayload.StuName
    payload['TranscriptId'] = submitpayload.TranscriptId
    payload['ForeignUni'] = submitpayload.ForeignUni
    payload['UniName'] = submitpayload.UniName
    payload['UniAddress'] = submitpayload.UniAddress
    payload['IsWES'] = submitpayload.IsWES
    payload['UniDocName'] = submitpayload.UniDocName
    payload['UniDocRefNo'] = submitpayload.UniDocRefNo
    payload['UniDocUpload'] = this.uploadDoc2 ? this.uploadDoc2 : submitpayload.UniDocUpload
    payload['PostalAdd'] = submitpayload.PostalAdd
    payload['EmailId'] = submitpayload.EmailId
    payload['DeliveryOpt'] = submitpayload.DeliveryOpt
    this.umsService.UpdateTranscript(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.UpdateTclc();
        // let data = {}
        // data['message'] = "Submitted Successfully"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   // this.SaveDisabled = true;
        //   this.ShowGrid()
        // });

      }
      else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    })
  }

  UpdateTclc() {
    const submitpayload = this.TranscriptForm.value
    let payload = {}
    payload['StuFaculty'] = '',
      payload['StuCourse'] = submitpayload.StuCourse,
      payload['StuCollege'] = submitpayload.StuClg,
      payload['StuExam'] = '',
      payload['StuBranch'] = '',
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = 'TS',
      payload['DestClg'] = '',
      payload['Reason'] = '',
      payload['Other'] = '',
      payload['FeeStatus'] = this.FeeStatus;
    payload['CertStatus'] = 'ReSubmitted';
    payload['StuId'] = this.StuId;
    payload['Comment'] = '';
    payload['CertScr'] = '';
    payload['StatusBy'] = sessionStorage.getItem('loginId');
    payload['DocStatus'] = 'Y';
    payload['TclcId'] = this.TclcId,
      this.umsService.UpdateTclc(payload).subscribe((res) => {
        if (res.status) {
          // this.spinner.hide()
          this.UpdateTclcDoc()
          // let data = {}
          // data['message'] = "Updated Successfully"
          // data['title'] = 'Information'
          // data['icon'] = 'fas fa-check'
          // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          // // this.SaveDisabled = true;
          // this.ShowGrid();
        }
        else {
          this.spinner.hide()
          let data = {}
          data['message'] = res.message
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
          AlertboxComponent,
          data
        );
      })
  }

  UpdateTclcDoc() {
    const submitpayload = this.TranscriptForm.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.TranscriptForm.controls.arrData.value.forEach((element, index, array) => {
        let srno = index + 1
        let payload = {};
        payload['StuId'] = this.StuId,
          payload['CertType'] = 'TS',
          payload['DocName'] = element.DocumentName,
          payload['FileUpload'] = this.fileUploads[index] == undefined ? element.DocumentFile : this.fileUploads[index];
        payload['TclcDocId'] = element.TclcDocId,
          payload['SrNo'] = srno
        setTimeout(() => {
          this.umsService.UpdateTclcDoc(payload).subscribe(res => {
            // this.spinner.hide();
            if (res.status == false) {
              // this.spinner.hide()
              iserror = true;
              this.errMsg = res.message;
            } else {
              // this.spinner.hide()
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            // this.fetchDocument();
            if(this.fileUploader != undefined){
              this.fileUploader.nativeElement.value = null;
            }
            
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      // this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();
        // this.saveApplicationDetails();
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.GetTranscript(this.StuId)
          // this.ShowGrid()
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ShowGrid()
        });
      }
    });

  }


  redirect(to): void {
    this.router.navigate([to]);
  }





  PayFees() {
    const Data = this.TranscriptForm.value
    this.Tclcdata.push({
      "StuCourse": Data.StuCourse,
      "StuClg": Data.StuClg,
      "SnNo": parseInt(sessionStorage.getItem('session')),
      "CertType": 'TS',
    })
    this.umsService.setTclcData(this.Tclcdata);
    this.redirect('TCLCFees')
  }

  TypeUni() {
    if (this.TranscriptForm.value['DestCollege'] == 'Other') {
      this.Other = true;
    }
    else {
      this.Other = false;
    }
  }

  getFeeTempData() {
    this.spinner.show();
    const payload = {};
    payload['FeeType'] = 'TS'
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      if (res.status) {
        this.addnewrecord(res.data[0]['TemplateCode'])
      }
    })
  }

  addnewrecord(TempCode) {
    let data = {};
    data['SnNo'] = parseInt(sessionStorage.getItem('session'))
    data['TemplateCode'] = TempCode;
    data['FeeType'] = 'TS'
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '90vh',
      height: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }



  isPhotoDocument(row: FormGroup): string {
    const documentName = row.get('DocumentName')?.value;
    return documentName === 'Photo of Student' ? '.png, .jpeg, .jpg' : '.pdf';
}


onFileSelected($event: Event) {
  const file = ($event.target as HTMLInputElement).files[0];
  const fileName = file.name;
  this.fileName = fileName;
  if (file.size >= 3000000) {
    this.errormessage = "Please upload file less than 3 MB";
    let data = {}
    data['message'] = this.errormessage
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.fileName = '';
      ($event.target as HTMLInputElement).value = '';
    });
  }
  else {
    this.errormessage = '';
    let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
    if ( ext.toLowerCase() == "pdf") {
      this.convertBase64(file);
    }
    else {
      let data = {}
      data['message'] = 'File not support'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
  }

}



convertBase64(file: File) {
  const observable = new Observable((subscriber: Subscriber<any>) => {
    this.readingFile(file, subscriber);
  });

  observable.subscribe((d) => {
    this.uploadDoc2 = d;
    this.TranscriptForm.get('UniDocUpload').clearValidators()
    this.TranscriptForm.get('UniDocUpload').updateValueAndValidity();
    this.TranscriptForm.get('UniDocUpload').setValue(d);
  });
}
readingFile(file: File, subscriber: Subscriber<any>) {
  const fileReader = new FileReader();
  fileReader.readAsDataURL(file);

  fileReader.onload = () => {
    subscriber.next(fileReader.result);
    subscriber.complete();
  };
  fileReader.onerror = (error) => {
    subscriber.error(error);
    subscriber.complete();
  };
}

onChange($event: Event, rowIndex: number) {
  const fileInput = $event.target as HTMLInputElement;
  const formArray = this.TranscriptForm.get('arrData') as FormArray;
  const formGroup = formArray.at(rowIndex) as FormGroup;

  const documentName = formGroup.get('DocumentName')?.value;
  // Set the accept attribute dynamically based on the document name
  if (documentName === 'Photo of student') {
    fileInput.setAttribute('accept', '.png, .jpeg, .jpg');
  } else {
    fileInput.setAttribute('accept', '.pdf');
  }

  // Get the selected file
  const file = fileInput.files[0];
  if (!file) {
    return; // Exit if no file is selected
  }

  this.fileName = file.name;
  const faControl = (<FormArray>this.TranscriptForm.controls['arrData']).at(rowIndex);

  // File size validation
  if (file.size >= 1000000) {
    this.errormessage = 'Please upload a file smaller than 1 MB';
    const data = {
      message: this.errormessage,
      title: 'Information',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.dialogRef.afterClosed().subscribe(() => {
      this.fileName = '';
      fileInput.value = '';
      faControl['controls'].docFile.setValue('');
      faControl['controls'].DocumentFile.setValue('');
    });
  } else {
    this.errormessage = '';
    const ext = this.fileName.substring(this.fileName.lastIndexOf('.') + 1).toLowerCase();

    if (documentName === 'Photo of student' && (ext === 'png' || ext === 'jpeg' || ext === 'jpg')) {
      // If the document is a photo, proceed with setting the file
      this.convertToBase64(file, rowIndex);
      faControl['controls'].DocumentFile.setValue(this.fileName);
      faControl['controls'].DocumentFile.markAsTouched();
    } else if (ext === 'pdf') {
      // If the document is a PDF, proceed with setting the file
      this.convertToBase64(file, rowIndex);
      faControl['controls'].DocumentFile.setValue(this.fileName);
      faControl['controls'].DocumentFile.markAsTouched();
    } else {
      // Invalid file type for the document
      faControl['controls'].docFile.setValue('');
      faControl['controls'].DocumentFile.setValue('');
      faControl['controls'].DocumentFile.markAsTouched();
      const data = {
        message: documentName === 'Photo of student' ? 'Please upload only PNG, JPEG, or JPG files' : 'Please upload only PDF files',
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        fileInput.value = '';
      });
    }
  }
}



  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      // while (this.fileUploads.length <= rowIndex) {
      //   this.fileUploads.push(null);
      // }
      if (!this.fileUploads) {
        this.fileUploads = [];  // Initialize if it's undefined
      }

      // Check if the rowIndex exists in the array, and if not, create a placeholder
      if (!this.fileUploads[rowIndex]) {
        this.fileUploads[rowIndex] = {}; // Initialize row if it's missing
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.TranscriptForm.controls['arrData']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);

    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  showbase64(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.value.DocumentFile
      });
  }

  showbase64new(e){
    const dialogRef3 = this.dialog.open(PdfviewerComponent, { width: "400px", height: "500px", data: e });
  }

  dowload(){
    // var filter: any;
    // let payload1 = {}
    // payload1['StuId'] = this.StuId;
    // let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
    // var filter: any;
    // filter = {
    //   "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
    //   "RptCode": 301,
    //   "InstName": '',
    //   "InstNo": this.InstId,
    //   "ShId": '',
    //   "CgCode": '',
    //   "RollNo": '',
    //   "Cent": '',
    //   "TnCode": '',
    //   "EsId": '',//this.emid
    //   "CsNo": '',
    //   "PgBreak": '',
    //   "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
    //   "StrCode": '',
    //   "RgNo": '',
    //   "UC": '',
    //   "Ledger": '',
    //   "RegnRoll": '',
    //   "DsCode": '',
    //   "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
    //   "SnNo": parseInt(sessionStorage.getItem('session')),
    //   "Extra1": JSON.stringify(payload1),
    // }
    // var payload: any;
    // payload = filter;
    // this.umsService.setData(JSON.stringify(payload));
    // this.redirect('reports')
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.AdminUpload[0].FileUpload
      });
  }

  
  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  fetchApplyUni() {
    const payload = {};
    payload['CdType'] = 'APUN';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.applyUniversity = res.data;
        this.filteredapplyUniversity = this.applyUniversity.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  UploadedDocs(){
    this.spinner.show()
    let payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
    payload['StuId'] = this.StuId
    this.umsService.GetTcLcDocUploadDetails(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.AdminUpload = res.data
        
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  ValidateFee(StuId,FeeType,Data){
    const payload = {}
    payload['StuId'] = StuId;
    payload['FeeType'] = FeeType;
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      this.getFeeTempData2(StuId,FeeType,Data);
    })
  }

  getFeeTempData2(StuId, FeeType,Data) {
     this.spinner.show();
     const payload = {};
     payload['FeeType'] = FeeType;
     this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
       this.spinner.hide();
       if (res.status) {
         this.SearchFeeDetails(res.data[0]['TemplateCode'], StuId,Data)
         
       } else {
         this.spinner.hide();
         if (res.message == 'No Data Found') {
           
         }
 
       }
     });
   }

   SearchFeeDetails(TempCode, StdId, Data) {
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = sessionStorage.getItem('session')
    this.umsService.getSearchTranscriptFeeDetails(payload).subscribe((res) => {


      this.spinner.hide();
      if (res.status) {
        this.updateTC(StdId,Data)
        // let data = 0
        // res.data.forEach(element => {
        //   data += element.FeeAmt
        // });
        // if (data == res.data[0]['TotalPaidAmount']) {
          
        // }
        // else if (data != res.data[0]['TotalPaidAmount']) {
        // }
      } else {
        this.PayDisabled = false;
        this.PayRecpt = false;
        this.PayFee = true
      }
    });

  }

  updateTC(StdId, Data){
    let payload = {}
    payload['StuFaculty'] = Data['StuFaculty'],
    payload['StuCourse'] = Data['StuCourse'],
    payload['StuCollege'] = Data['StuCollege'],
    payload['StuExam'] = Data['StuExam'],
    payload['StuBranch'] = Data['StuBranch'],
    payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
    payload['CertType'] = Data['CertType'],
    payload['DestClg'] = Data['DestClg'],
    payload['Reason'] = Data['Reason'],
    payload['FeeStatus'] = 'Y';
    payload['CertStatus'] = 'Fees Paid';
    payload['StuId'] = Data['StuId'],
    payload['TclcId'] = Data['TclcId'],
    payload['Comment'] = '',
    payload['CertScr'] = '',
    payload['StatusBy'] = sessionStorage.getItem('loginId'),
    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if(res.status){
        this.getTclcData(StdId)
      }
    })
  }

}